<template>
    <div class="center_goods_list">
        <!-- 商品图片 -->
        <div class="center_goods_list_img_box">
            <router-link 
                class="center_goods_list_img"
                :to="{name: 'pdetail', query:{id: goods.goods_id},params:{cate_id:goods.cat_id}}">
                <img v-lazy="goods.goods_images[0]" alt="">
            </router-link>
        </div>
        <!-- 商品标题 -->
        <router-link 
            :to="{name: 'pdetail', query:{id: goods.goods_id},params:{cate_id:goods.cat_id}}"
            class="center_goods_list_title">
            <span>{{goods.goods_name}}</span>
        </router-link>
        <!-- 价格 & 加入购物车 -->
        <div class="center_goods_list_price_add">
            <!-- 价格 -->
            <div class="center_goods_list_price">
                <template v-if="powerPrice && (show_price || !!goods.personal_price)">
                    <!-- 货币单位 -->
                    <span>{{currency}}</span>
                    <!-- 价格 -->
                    <span>{{goods.personal_price || goods.shop_price}}</span>
                </template>
            </div>
            <!-- 加入购物车 -->
            <div class="center_goods_list_add">
                <!--  -->
                <el-button
                    type="info"
                    @click="addCart(goods.goods_id)"
                    class="center_goods_list_add_btn"
                    round>
                    <!-- 图标 -->
                    <span class="center_goods_list_add_btn_icon">
                        <i class="glyphicon glyphicon-shopping-cart"></i>
                    </span>
                    <!-- 文字 -->
                    <span class="center_goods_list_add_btn_text">{{$t("message.ccoll.addCart")}}</span>
                </el-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

export default {
    props: [ "goods" ],
    computed: {
        ...mapState({
            islogin: state => state.user.islogin,
            currency: state => state.currency,
            show_price: state => state.show_price
        }),
        ...mapGetters([
            'powerPrice',
        ])
    },
    methods: {
        ...mapMutations([
            "handleDialog",
        ]),
        ...mapActions([
            "getPdetail",
        ]),
        addCart(goods_id){ // 添加购物车
            // 判断是否登录
            if(!this.islogin){
                this.$confirm(this.$t("public.notLogin"), {
                    confirmButtonText: this.$t("public.goLogin"),
                    cancelButtonText: this.$t("public.cancelBtn"),
                    type: 'warning',
                    center: true
                }).then(() => {
                    this.$router.push('/login');
                }).catch(() => {});
                return
            }
            this.getPdetail(goods_id); // 获取商品信息
            this.handleDialog(true); // 打开模态框
        },
    },
}
</script>

<style scoped>
.center_goods_list{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 10px;
    height: 310px;
}
/* 商品图片 */
.center_goods_list_img_box{
    position: relative;
    display: block;
    width: 100%;
    border: 1px solid #EBEEF5;
    overflow: hidden;
}
.center_goods_list_img_box::before{
    display: block;
    content: "";
    padding-top: 100%;
}
.center_goods_list_img_box>a{
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 100%;
}
.center_goods_list_img_box>a>img{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 100%;
    max-height: 100%;
}

/* 商品标题 */
.center_goods_list_title{
    display: block;
    width: 100%;
    padding: 0 10px;
    text-align: center;
    color: #606266;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.center_goods_list_title:hover{
    color: #ff6700;
}

/* 价格 & 购物车 */
.center_goods_list_price_add>div{
    display: inline-block;
    width: 50%;
}
/* 价格 */
.center_goods_list_price{
    padding-right: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.center_goods_list_price>span:last-child{
    margin-left: 5px;
    color: #ff6700;
    font-weight: bold;
}

/* 加入购物车 */
.center_goods_list_add_btn{
    float: right;
    padding: 0px !important;
}
/* 图标 */
.center_goods_list_add_btn_icon{
    display: inline-block;
    vertical-align: middle;
    border-radius: 50%;
    margin-right: 5px;
    padding: 5px;
    background-color: #ff6700;
}
/* 文字部分 */
.center_goods_list_add_btn_text{
    margin-right: 10px;
    font-size: 12px;
}
</style>
